export default "__VITE_ASSET__D5l$$O$T__"